'use client';

import React from 'react';
import Link from 'next/link';

export function BannerMoreArticles() {
  return (
    <div className="rounded-xl border border-gray-100 bg-transparent flex flex-col md:flex-row justify-between items-center p-6 mt-4">
      <div className="flex flex-col">
        <p className="text-gray-800">
          <strong>Deseja ver mais conteúdo?</strong> Explore o arquivo completo com todos os artigos
          publicados.
        </p>
      </div>

      <Link
        href="/artigos"
        className="border border-[#C09957] text-[#C09957] hover:bg-[#CFA969] hover:text-white flex items-center gap-4 rounded-full font-bold text-sm transition-colors px-6 py-2 h-10 w-full md:w-auto mt-4 md:mt-0 justify-center min-w-48"
      >
        Ler todos os artigos
      </Link>
    </div>
  );
}
